<template>
    <page>
        <fast-table
            v-if="dataLoaded"
            :sections="sections"
            :headers="headers"
            :data="tableData"
            :activeRowId="currentLawId"
            @click="currentLawId = $event.id"
        >
            <template v-slot:table-actions>
                <button type="button" class="btn btn-primary btn-collapse-md" @click.prevent="currentLawId = null; addModalOpen = true">
                    <i class="far fa-fw fa-plus"></i>
                    <span class="btn-text">Add Involuntary Withholding Law</span>
                </button>
            </template>
        </fast-table>

        <sidebar
            :key="currentLawId"
            :involuntary-withholding-law-id="currentLawId"
            :involuntary-withholding-types="involuntaryWithholdingTypes"
            v-if="currentLawId"
            @updated="onUpdate($event)"
            @deleted="currentLawId = null; getData()"
            @close="currentLawId = null"
        />

        <add-modal
            v-if="addModalOpen"
            :involuntary-withholding-types="involuntaryWithholdingTypes"
            @updated="getData()"
            @close="addModalOpen = false"
        />
    </page>
</template>

<script>
import FastTable from '@/components/FastTable'
import Page from '@/components/Page'
import AddModal from './components/InvoluntaryWithholdingLawModal'
import Sidebar from './components/InvoluntaryWithholdingLawSidebar'

export default {
    components: {FastTable, Page, Sidebar, AddModal, },
    computed: {
        tableData() {
            const sectionData = this.involuntaryWithholdingLaws.map(law => ({
                id: law.id,
                isActive: this.currentLawId && law.id == this.currentLawId,
                object: law,
                cells: [
                    law.involuntary_withholding_type.type_pretty,
                    law.jurisdiction_display,
                ],
            }))
            return [sectionData]
        },
    },
    data() {
        return {
            involuntaryWithholdingLaws: [],
            involuntaryWithholdingTypes: [],
            dataLoaded: false,
            currentLawId: null,
            addModalOpen: false,

            headers: [
                {label: 'Type', classes: '', isSearchable: true, isFilterable: true},
                {label: 'Jurisdiction', classes: 'cw-24', isSearchable: true, isFilterable: true, defaultSort: true},
            ],
            sections: [
                {title: '', defaultIsClosed: false, id: 1},
            ],
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Tax Engine / Involuntary Withholding Laws')
        this.getData()
    },
    methods: {
        getData() {
            this.dataLoaded = false

            const promises = []
            this.$store.dispatch('START_LOADING')

            promises.push(this.$api.get(`/admin/tax-engine/involuntary-withholding-laws`).then(resp => {
                this.involuntaryWithholdingLaws = resp
            }).catch((errors) => {
                this.$bus.showError(errors.__all__)
            }))

            promises.push(this.$api.get(`/admin/tax-engine/involuntary-withholding-types`).then(resp => {
                this.involuntaryWithholdingTypes = resp
            }).catch((errors) => {
                this.$bus.showError(errors.__all__)
            }))

            Promise.all(promises).then(() => {
                this.dataLoaded = true
                this.$store.dispatch('STOP_LOADING')
            }).catch(() => {
                this.$store.dispatch('STOP_LOADING')
            })
        },
        onUpdate(law) {
            if (law) {
                const existing = this.involuntaryWithholdingLaws.find(x => x.id == law.id)
                if (existing) {
                    Object.assign(existing, law)
                }
                else {
                    this.involuntaryWithholdingLaws.push(law)
                }
            }
            else {
                this.getData()
            }
        },
    },
}

</script>
